<template>
  <div class="topic-block">
    <div
      class="mark"
      :class="{ error: mark === 2, correct: mark === 1, done: mark === 3 }"
    >
      <template v-if="mark === 0">未答</template>
      <template v-else-if="mark === 1">正确</template>
      <template v-else-if="mark === 2">错误</template>
      <template v-else-if="mark === 3">已答</template>
    </div>
    <div class="topic-number" :class="{ highlight: highlight }">
      第{{ indexVal }}题
    </div>
  </div>
</template>

<script>
export default {
  name: "TopicBlock",
  props: {
    mark: {
      //0灰色（未答），1绿色（正确），2红色（错误）,3黄色（已答）
      type: Number,
      default: 0
    },
    index: {
      type: Array,
      default: function() {
        return [0];
      }
    },
    highlight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 计算属性的 getter
    indexVal: function() {
      let len = this.index.length;
      if (len === 1) {
        return this.index[0];
      }
      if (len > 1) {
        return this.index[0] + "~" + this.index[len - 1];
      }
      return "";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.topic-block {
  cursor: pointer;
  width: 100%;
  align-items: center;
  min-height: 26px;
  display: flex;
  .mark {
    color: #fff;
    font-size: 12px;
    width: 38px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    border-radius: 2px;
    background: #b3b3b3;
    margin-right: 10px;
    &.error {
      background-color: #dd3b3b;
    }
    &.correct {
      background-color: #31b359;
    }
    &.done {
      background-color: #f2a536;
    }
  }
  .topic-number {
    flex: 1;
    color: #666666;
    font-size: 16px;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; //溢出不换行
  }
  .highlight {
    color: #f2a536;
  }
}
</style>
